import { commonAppLog } from './common-app';

export enum WidgetsLog {
  REACT_ERROR = 'react.error',
  ROUTE_ERROR = 'route.error'
}

const widgetsLog = commonAppLog.extend().bindEnum(WidgetsLog);

export default widgetsLog;
